<div id="isd_container">
  <div class="inner_container bm-card bg-base-100 text-base-content w-[900px] max-w-[95vw] shadow-lg">
    <div class="bm-card-body gap-4">
      @if (insufficientInstanceAmount > 0) {
        <div class="bm-card-title">
          {{ insufficientInstanceAmount }}
          @if (insufficientInstanceAmount === 1) {
            Auftrag ohne gültige Koordinaten
          } @else {
            Aufträge ohne gültige Koordinaten
          }
        </div>

        <div class="bm-alert bm-alert-warning bm-alert-soft">
          <span>
            Diese Aufträge lassen sich weder auf der Karte anzeigen noch in eine Route einrechnen.
            Sie können entweder eine gültige Adresse hinterlegen, oder den Auftrag für diese Sitzung aus der Planung
            nehmen, um bewusst um den Auftrag herum zu planen.
          </span>
        </div>
      }

      <!-- Auftragsliste und Adresssuche. Bewusst nur ausgeblendet statt entfernt:
           der Geocoder hängt fest an #ins_data_geocoder und wäre nach einem
           Ausbau aus dem DOM verloren. -->
      <div [class.hidden]="!!bulkExclusionSummary" class="flex flex-col gap-4 md:flex-row">
        <div class="flex max-h-[45vh] flex-1 flex-col gap-1 overflow-y-auto">
          @for (entry of classifiedOperations(); track entry.operation.id) {
            <!-- Die ganze Zeile wählt den Auftrag für die Adresssuche rechts —
                 die Hervorhebung ist der einzige Anker dafür, welcher Auftrag
                 dort gerade bearbeitet wird. -->
            <div
              class="flex cursor-pointer flex-row flex-wrap items-center gap-2 rounded border p-2"
              [class.border-primary]="entry.operation === selectedInstance"
              [class.bg-base-200]="entry.operation === selectedInstance"
              [class.border-base-300]="entry.operation !== selectedInstance"
              (click)="selectInstance(entry.operation)"
            >
              <!-- min-w-0 ist nötig, damit lange Firmennamen im Flex-Element
                   umbrechen statt die Knöpfe aus der Zeile zu schieben. -->
              <div class="flex min-w-0 flex-1 flex-col">
                <span class="font-bold break-words">{{ getOperationName(entry.operation) }}</span>
                <span class="text-sm break-words opacity-70">
                  @if (entry.planned) {
                    Tour: {{ entry.technicianName }}, {{ entry.dateString }}
                  } @else {
                    ungeplant
                  }
                </span>
              </div>
              <a class="bm-btn bm-btn-sm bm-btn-ghost shrink-0" [href]="entry.operation.hawkLink" target="_blank">
                Hawk
              </a>
              <button class="bm-btn bm-btn-sm bm-btn-error shrink-0" (click)="excludeOperation(entry.operation)">
                Ausschließen
              </button>
            </div>
          }
        </div>

        <div class="flex flex-1 flex-col gap-2">
          @if (selectedInstance) {
            <span>Bitte geben Sie für den markierten Auftrag eine gültige Adresse (inkl. Koordinaten) an!</span>
          }
          <div id="ins_data_geocoder"></div>
          <button
            class="bm-btn bm-btn-primary self-start"
            [disabled]="!selectedInstanceIsReadyToUpdate()"
            (click)="updateSelectedInstance()"
          >
            Adresse updaten
          </button>
        </div>
      </div>

      @if (insufficientInstanceAmount > 1 && !bulkExclusionSummary) {
        <div class="flex flex-row justify-end">
          <button class="bm-btn bm-btn-error" (click)="startBulkExclusion()">
            Alle {{ insufficientInstanceAmount }} aus der Planung ausschließen
          </button>
        </div>
      }

      <!-- Aufstellung vor dem Sammelausschluss -->
      @if (bulkExclusionSummary) {
        <div class="bm-card-title">
          {{ bulkExclusionSummary.unplanned.length + bulkExclusionSummary.planned.length }} Aufträge aus der Planung
          ausschließen?
        </div>

        <div class="flex flex-col gap-2">
          <span>{{ bulkExclusionSummary.unplanned.length }} davon sind ungeplant.</span>

          @if (bulkExclusionSummary.planned.length) {
            <span class="font-bold">
              {{ bulkExclusionSummary.planned.length }} sind bereits in einer Tour eingeplant und werden dort
              für diese Sitzung unsichtbar:
            </span>
            <div class="flex max-h-[30vh] flex-col gap-1 overflow-y-auto">
              @for (entry of bulkExclusionSummary.planned; track entry.operation.id) {
                <div class="rounded border border-base-300 p-2 break-words">
                  {{ entry.technicianName }}, {{ entry.dateString }} — {{ getOperationName(entry.operation) }}
                </div>
              }
            </div>
          } @else {
            <span>Keiner davon ist in einer Tour eingeplant.</span>
          }

          <div class="bm-alert bm-alert-info bm-alert-soft">
            <span>
              Der Ausschluss gilt nur für diese Sitzung. Nach einem Neuladen des Planungsassistenten sind die Aufträge
              wieder da.
            </span>
          </div>
        </div>

        <div class="flex flex-row justify-end gap-2">
          <button class="bm-btn" (click)="cancelBulkExclusion()">Abbrechen</button>
          <button class="bm-btn bm-btn-error" (click)="confirmBulkExclusion()">Ausschließen</button>
        </div>
      }

    </div>
  </div>
</div>
